export default "__VITE_ASSET__BupIF8Gc__"